import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Equipment } from "../../features/CourseBuilder/components/EquipmentsTab/types/types";

export interface EquipmentState {
	equipments: Equipment[];
	selectedEquipment: Equipment | null;
	isLoading: boolean;
	error: string | null;
	currentPage: number;
	totalPages: number;
	totalItems: number;
}

const initialState: EquipmentState = {
	equipments: [],
	selectedEquipment: null,
	isLoading: false,
	error: null,
	currentPage: 1,
	totalPages: 0,
	totalItems: 0,
};

const equipmentSlice = createSlice({
	name: "equipment",
	initialState,
	reducers: {
		setEquipments(state, action: PayloadAction<Equipment[]>) {
			state.equipments = action.payload;
		},
		addEquipment(state, action: PayloadAction<Equipment>) {
			state.equipments.unshift(action.payload);
		},
		updateEquipment(state, action: PayloadAction<Equipment>) {
			const index = state.equipments.findIndex(eq => eq.uuid === action.payload.uuid);
			if (index !== -1) {
				state.equipments[index] = action.payload;
			}
		},
		removeEquipment(state, action: PayloadAction<string>) {
			state.equipments = state.equipments.filter(eq => eq.uuid !== action.payload);
		},
		setSelectedEquipment(state, action: PayloadAction<Equipment | null>) {
			state.selectedEquipment = action.payload;
		},
		setLoading(state, action: PayloadAction<boolean>) {
			state.isLoading = action.payload;
		},
		setError(state, action: PayloadAction<string | null>) {
			state.error = action.payload;
		},
		setPagination(state, action: PayloadAction<{ page: number; totalPages: number; totalItems: number }>) {
			state.currentPage = action.payload.page;
			state.totalPages = action.payload.totalPages;
			state.totalItems = action.payload.totalItems;
		},
		clearEquipments(state) {
			state.equipments = [];
			state.selectedEquipment = null;
			state.currentPage = 1;
			state.totalPages = 0;
			state.totalItems = 0;
		},
	},
});

export const {
	setEquipments,
	addEquipment,
	updateEquipment,
	removeEquipment,
	setSelectedEquipment,
	setLoading,
	setError,
	setPagination,
	clearEquipments,
} = equipmentSlice.actions;

export default equipmentSlice.reducer;
